/* P0 extras for the Farmstead pack: buildings, crate states, cursors, FX layer.
   Requires sprites.js first. Exposes window.SpriteExtras = { extras() }. */
(function () {
  const L = window.SpriteLib || globalThis.SpriteLib;
  const { G, px, rect, disc, outline, hash } = L;
  const T = 24;

  // FX-only blended colours (the FX layer is the one place partial alpha is allowed)
  Object.assign(L.PAL_FX, {
    sh1: 'rgba(23,20,32,0.35)',
    sh2: 'rgba(23,20,32,0.22)',
    wA: 'rgba(244,236,224,0.80)',
    wB: 'rgba(244,236,224,0.45)',
    cA: 'rgba(87,168,216,0.80)',
    cB: 'rgba(42,95,168,0.45)',
    yA: 'rgba(244,224,122,0.85)',
    bA: 'rgba(125,90,60,0.80)',
    gA: 'rgba(98,171,82,0.85)'
  });

  /* ---- buildings ---- */
  function house() {
    const g = G(72, 80);
    // chimney + smoke
    rect(g, 52, 2, 8, 18, 'n2'); rect(g, 52, 2, 8, 2, 'n3'); rect(g, 58, 4, 2, 16, 'n1');
    for (let y = 4; y < 20; y += 3) px(g, 54 + (y % 2), y, 'n1');
    disc(g, 49, 2, 2.2, 1.6, 'w'); disc(g, 45, 0, 1.6, 1.2, 'w');
    // shingled gable
    for (let y = 6; y <= 34; y++) {
      const half = Math.round((y - 6) * 1.2) + 2;
      const x0 = Math.max(1, 36 - half), x1 = Math.min(70, 35 + half), row = (y - 6) % 4;
      rect(g, x0, y, x1 - x0 + 1, 1, row === 0 ? 'r2' : row === 3 ? 'b1' : 'r1');
    }
    rect(g, 33, 5, 6, 2, 'b1');
    // plank walls
    rect(g, 8, 34, 56, 42, 'b3');
    for (let y = 37; y < 76; y += 4) rect(g, 8, y, 56, 1, 'b1');
    rect(g, 8, 34, 2, 42, 'b4'); rect(g, 62, 34, 2, 42, 'b2');
    // windows
    const win = (x, y) => {
      rect(g, x, y, 14, 12, 'K'); rect(g, x + 1, y + 1, 12, 10, 'c2');
      rect(g, x + 6, y + 1, 2, 10, 'K'); rect(g, x + 1, y + 5, 12, 2, 'K');
      rect(g, x + 2, y + 2, 3, 3, 'w');
    };
    win(12, 40); win(46, 40);
    // door + porch lip
    rect(g, 28, 52, 16, 24, 'b1'); rect(g, 29, 53, 14, 23, 'b2');
    rect(g, 31, 55, 10, 9, 'b1'); px(g, 40, 65, 'y1'); px(g, 40, 66, 'b4');
    rect(g, 4, 76, 64, 3, 'b4'); rect(g, 4, 79, 64, 1, 'b1');
    outline(g, 'K');
    return g;
  }

  function houseDoorOpen() {
    const g = G(24, 32);
    rect(g, 2, 3, 20, 29, 'b1');
    rect(g, 4, 5, 16, 27, 'K');
    rect(g, 5, 6, 14, 22, 'D');
    rect(g, 6, 8, 5, 8, 'K'); rect(g, 13, 10, 4, 6, 'K');
    rect(g, 5, 28, 14, 2, 'y1'); rect(g, 6, 30, 12, 2, 'y2');
    px(g, 8, 27, 'y1'); px(g, 15, 27, 'y1');
    outline(g, 'K');
    return g;
  }

  function crateBase() {
    const g = G(24, 22);
    rect(g, 2, 4, 20, 17, 'b3');
    rect(g, 2, 4, 20, 2, 'b4'); rect(g, 2, 19, 20, 2, 'b1');
    rect(g, 11, 6, 2, 13, 'b2'); rect(g, 2, 11, 20, 2, 'b2');
    rect(g, 2, 4, 2, 17, 'b2'); rect(g, 20, 4, 2, 17, 'b2');
    return g;
  }

  function crateFull() {
    const g = crateBase();
    disc(g, 7, 3, 3, 2.4, 'r1'); px(g, 6, 2, 'r2'); px(g, 7, 0, 'g2');
    rect(g, 11, 0, 3, 5, 'y1'); rect(g, 11, 0, 1, 5, 'y2'); px(g, 14, 1, 'g3');
    disc(g, 18, 3, 3, 2.4, 'g3'); disc(g, 17, 2, 1.6, 1.2, 'g4');
    outline(g, 'K');
    return g;
  }

  function crateOpen() {
    const g = crateBase();
    // interior
    rect(g, 4, 4, 16, 6, 'b1'); rect(g, 4, 4, 16, 1, 'K'); rect(g, 4, 9, 16, 1, 'y2');
    // lid hinged back
    rect(g, 3, 0, 18, 3, 'b3'); rect(g, 3, 0, 18, 1, 'b4'); rect(g, 3, 3, 18, 1, 'b1');
    outline(g, 'K');
    return g;
  }

  /* ---- cursors ---- */
  function cursor(kind) {
    const g = G(T, T);
    const c = kind === 'hand' ? 'g4' : 'r1', c2 = kind === 'hand' ? 'g3' : 'r2';
    const corner = (x, y, sx, sy) => {
      rect(g, x, y, 7 * sx > 0 ? 7 : 7, 2, c);
      rect(g, x + (sx < 0 ? 5 : 0), y, 2, 7, c);
    };
    // four L brackets
    rect(g, 3, 3, 7, 2, c); rect(g, 3, 3, 2, 7, c);
    rect(g, 14, 3, 7, 2, c); rect(g, 19, 3, 2, 7, c);
    rect(g, 3, 19, 7, 2, c); rect(g, 3, 14, 2, 7, c);
    rect(g, 14, 19, 7, 2, c); rect(g, 19, 14, 2, 7, c);
    if (kind === 'blocked') for (let i = 0; i < 12; i++) { px(g, 6 + i, 6 + i, c); px(g, 7 + i, 6 + i, c2); }
    else { rect(g, 11, 11, 2, 2, c2); }
    outline(g, 'K');
    return g;
  }

  /* ---- FX (no outline, blended layer) ---- */
  function fxDirt(f) {
    const g = G(T, T);
    const specks = [[-8, -1], [-6, -4], [-3, -6], [0, -8], [3, -6], [6, -4], [8, -1], [-4, 1], [4, 1], [-1, -3], [1, -5]];
    specks.forEach(([dx, dy], i) => {
      const spread = f === 0 ? 0.45 : f === 1 ? 1 : 1.35;
      const rise = f === 0 ? 0.35 : f === 1 ? 1 : 0.55;
      const x = 12 + Math.round(dx * spread), y = 19 + Math.round(dy * rise);
      const c = f === 2 ? 'bA' : i % 3 === 0 ? 'b1' : i % 2 ? 'b2' : 'b3';
      const s = f === 2 ? 1 : i % 3 === 0 ? 3 : 2;
      rect(g, x, y, s, s, c);
    });
    if (f === 0) { rect(g, 8, 18, 8, 3, 'b2'); rect(g, 9, 17, 6, 1, 'b3'); }
    if (f === 1) { rect(g, 7, 20, 10, 1, 'b1'); }
    if (f === 2) { rect(g, 6, 20, 12, 1, 'bA'); rect(g, 4, 21, 3, 1, 'bA'); rect(g, 17, 21, 3, 1, 'bA'); }
    return g;
  }

  function fxSplash(f) {
    const g = G(T, T);
    const drops = [[2, -3], [4, -1], [6, 1], [8, 3], [10, 6], [3, 2], [6, 4], [9, 8], [1, 0], [12, 4]];
    drops.forEach(([dx, dy], i) => {
      const x = 6 + Math.round(dx * (0.55 + f * 0.35)), y = 7 + Math.round(dy * (0.7 + f * 0.4)) + f * 2;
      const c = i % 3 === 0 ? 'wA' : 'cA';
      rect(g, x, y, 2, i % 2 ? 2 : 1, c);
      if (f < 2) px(g, x, y + 2, 'cB');
    });
    if (f >= 1) { for (let i = 0; i < 16; i++) px(g, 4 + i, 20 - (i % 3 === 0 ? 1 : 0), 'cB'); }
    if (f === 2) { rect(g, 6, 21, 13, 1, 'cA'); rect(g, 8, 22, 9, 1, 'cB'); }
    return g;
  }

  function fxLeaves(f) {
    const g = G(T, T);
    const seeds = [[3, 2], [9, 0], [15, 4], [6, 8], [13, 10], [18, 7]];
    seeds.forEach(([x, y], i) => {
      const yy = y + f * 5 + (i % 2), xx = x + (i % 2 ? f * 2 : -f * 2);
      const c = i % 3 === 0 ? 'g2' : i % 2 ? 'g3' : 'g4';
      if (f === 2) { rect(g, xx, yy, 2, 1, 'gA'); px(g, xx + 2, yy + 1, 'gA'); }
      else {
        rect(g, xx, yy, 3, 2, c);
        px(g, xx + (i % 2 ? 3 : -1), yy + (f ? 2 : 1), 'g2');
        px(g, xx + 1, yy - 1, i % 2 ? 'g4' : 'g3');
      }
    });
    return g;
  }

  function fxSparkle(f) {
    const g = G(16, 16);
    const r = [1, 3, 5, 3][f], c = f === 3 ? 'wB' : f === 0 ? 'wA' : 'y2';
    for (let i = 0; i <= r; i++) { px(g, 8, 8 - i, c); px(g, 8, 8 + i, c); px(g, 8 - i, 8, c); px(g, 8 + i, 8, c); }
    if (f >= 1) { px(g, 8, 8, 'w'); px(g, 7, 8, 'yA'); px(g, 9, 8, 'yA'); }
    if (f === 2) { px(g, 5, 5, 'yA'); px(g, 11, 11, 'yA'); px(g, 11, 5, 'yA'); px(g, 5, 11, 'yA'); }
    return g;
  }

  function fxShadow() {
    const g = G(T, 8);
    disc(g, 12, 4, 10, 3.4, 'sh2');
    disc(g, 12, 4, 8, 2.4, 'sh1');
    return g;
  }

  function extras() {
    const out = [];
    const add = (cat, id, grid, meta) => out.push(Object.assign({ cat, id, grid, w: grid.w, h: grid.h }, meta || {}));
    add('props', 'house', house(), { priority: 'P0' });
    add('props', 'house_door_open', houseDoorOpen(), { priority: 'P0' });
    add('props', 'crate_full', crateFull(), { priority: 'P0' });
    add('props', 'crate_open', crateOpen(), { priority: 'P0' });
    add('ui', 'ui_cursor_hand', cursor('hand'), { priority: 'P0' });
    add('ui', 'ui_cursor_blocked', cursor('blocked'), { priority: 'P0' });
    [0, 1, 2].forEach(f => add('fx', 'fx_dirt_' + f, fxDirt(f), { priority: 'P0', anim: 'fx_dirt', frame: f, blended: true }));
    [0, 1, 2].forEach(f => add('fx', 'fx_splash_' + f, fxSplash(f), { priority: 'P0', anim: 'fx_splash', frame: f, blended: true }));
    [0, 1, 2].forEach(f => add('fx', 'fx_leaves_' + f, fxLeaves(f), { priority: 'P0', anim: 'fx_leaves', frame: f, blended: true }));
    [0, 1, 2, 3].forEach(f => add('fx', 'fx_sparkle_' + f, fxSparkle(f), { priority: 'P0', anim: 'fx_sparkle', frame: f, blended: true }));
    add('fx', 'fx_shadow', fxShadow(), { priority: 'P0', blended: true });
    return out;
  }

  const api = { extras, house, crateFull, crateOpen, cursor };
  if (typeof window !== 'undefined') window.SpriteExtras = api;
  if (typeof globalThis !== 'undefined') globalThis.SpriteExtras = api;
})();
